export const ddSnapAddresses = [
    "FfmJvEwVkea6GZ1iPS3iGf8Sgrg2yRwFvrk25LUtcVQv",
    "DGCSmti7PkEiieHhkVPj5Njk3DvHrfUGy9BHC3SKertU",
    "7NAwgbT17uNdB47rs2j9MoBrKWPgYcauhZtKKwSzL2Jf",
    "6PvwE3Qf2gm6XKhgiT7BsuVih7KUC6SAGwhz6hsEULC",
    "6Nwj5JWNMy827Uzxe8aF7Dhhd6CMu1SEJWfv315gQ5P3",
    "95PG9VqbpWi5ZSmxWAs6tbZ7iKvvP1cb7LABBveT8SAD",
    "erDDZCxYTaGYVBUnHqzBeWjzq9FPb1KpeXgcj4AoxLP",
    "6b2SoRsiAqbDUBS5YFmEcQ2FnM7ZoDTNv536q4v8r6Fx",
    "6Q6C9g9yaFej5n4QBy1ZN4yDrffWSNSPSZNk5qp39xqC",
    "HBh9p1yNSZLFX1bU8YGFoMp9Fh5ZMCfXjms7qzL7zEoY",
    "4gtcCiAUMTgf2DCjtcBUmy41grAFWuwpXrUTG7eEVBGb",
    "D8vdtfd6ZjzGdjmUGdp2YRZqenDZPkJ8kUB7pKRJLCWV",
    "Ar5uuis45kX5NWZySCFSqQDpWBM9q6kE8JgziZ7CjBgK",
    "5J8LFvmQvkUae5Cxwz1RBxMVt5PqWs6TrCAZKEcP2whx",
    "Cpgxp5AKx6tTgqWsfr2rPZfNq5Jn3APfDA26WZ3KXS16",
    "GDj1HKKi4HW4rq9XfVHCEUhMyyQMaHA32QaLKFAi35RP",
    "iUZX5qLLb3tYrqs2S1ScEMpgUae4pHj2caGxQfRoBCc",
    "Hbm3TR5bgsF6QotEZfeqgBLEQEhxdRRU2TM5BeYNWrcr",
    "3mnYS1PoTJyEQm6o67oxHtsEX4M4SCMYjijeQTX9MTEv",
    "EQGVz9vBYEAMBxsvNoJyRCRwy6yuYvoy1etbcwrtjAui",
    "DRygJdnKLcpXGphsEKzxSH7U9nqdsAZgdgN3sE4NsbNd",
    "5AVRhXArbTEF7qHYHDFKETYzwTw42NiYbMhU7mgdfraU",
]
